import { Box, BoxProps } from '@mui/material';
// @mui
import { useTheme } from '@mui/material/styles';
// next
import NextLink from 'next/link';

// ----------------------------------------------------------------------

interface LogoProps extends BoxProps {
  onDark?: boolean;
  isSimple?: boolean;
}

function Logo({ onDark = false, isSimple = false, sx }: LogoProps) {
  const theme = useTheme();
  const isLight = theme.palette.mode === 'light';

  const LIGHT_COLOR = theme.palette.common.white;
  const DARK_COLOR = theme.palette.grey[800];

  return (
    <NextLink href="/" passHref>
      <Box
        component="a"
        sx={{
          width: isSimple ? 64 : 75,
          lineHeight: 0,
          cursor: 'pointer',
          display: 'inline-flex',
          ...sx,
        }}
      >
        <svg
          enableBackground="new 0 0 95.1357 43.7266"
          version="1.1"
          viewBox="0 0 95.136 43.727"
          xmlSpace="preserve"
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="100%"
        >
          <defs>
            <linearGradient
              id="gradient1"
              x1="-369.68"
              x2="-368.68"
              y1="435.13"
              y2="435.13"
              gradientTransform="matrix(95.146 0 0 -95.146 35174 41435)"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#CC2229" offset="0" />
              <stop stopColor="#903035" offset="1" />
            </linearGradient>
          </defs>
          <path
            fill={isLight && !onDark ? DARK_COLOR : LIGHT_COLOR}
            d="m95.136 0.9273c-3.9023 1.3403-7.4209 2.9067-10.56 4.7002-3.1397 1.7934-5.8487 3.7309-8.127 5.8115-2.2793 2.0805-4.0957 4.1943-5.4502 6.3403-1.3545 2.1465-2.2627 4.2676-2.7256 6.3633h5.5576c0.4815-2.084 1.4092-4.0986 2.7871-6.0454h12.945v6.0454h5.5732v-23.215zm-16.185 14.204c2.6875-2.9991 6.2237-5.6826 10.611-8.0518v8.0518h-10.611zm-78.828-14.204v23.215c3.7002 0 6.6118-0.0254 8.7344-0.0742 2.3369-0.045 4.4658-0.3965 6.3872-1.0537 1.9209-0.65729 3.4263-1.5225 4.5161-2.5948 1.0898-1.0722 1.6348-2.2275 1.6348-3.4663 0-1.2285-0.3804-2.3208-1.1407-3.2778-0.7612-0.9565-1.7778-1.6992-3.0507-2.228 1.7524-0.9869 2.6284-2.1021 2.6284-3.3457 0-1.0528-0.3848-2.0103-1.1553-2.8741-0.7695-0.8632-1.957-1.6181-3.5615-2.2651s-3.6563-1.1484-6.1548-1.5034c-2.499-0.355-5.4448-0.5322-8.8379-0.5322zm5.5732 3.1508c1.9332 0.0855 3.5484 0.3394 4.8448 0.7618 1.2964 0.42279 2.2407 0.9262 2.8315 1.5092 0.5913 0.5835 0.8867 1.1646 0.8867 1.7437 0 1.5737-1.8007 2.8315-5.4018 3.772 2.3574 0.52389 4.1303 1.1928 5.3183 2.0073 1.1885 0.8154 1.7828 1.8364 1.7828 3.0635 0 1.2983-0.8804 2.3232-2.6416 3.0742-1.7608 0.75189-4.3013 1.1289-7.6207 1.1289v-17.061zm21.863 20.064c1.1719 0 2.1822-0.2246 3.0303-0.67191 0.84819-0.44819 1.2725-0.98629 1.2725-1.6162 0-0.6396-0.4243-1.1904-1.2725-1.6533-0.84811-0.4629-1.8584-0.6944-3.0303-0.6944-1.1533 0-2.1401 0.2315-2.9609 0.6944-0.8213 0.4629-1.2319 1.0137-1.2319 1.6533 0 0.6299 0.4106 1.168 1.2319 1.6162 0.8208 0.44731 1.8076 0.67191 2.9609 0.67191zm11.414-10.087h17.22v-3.041h-17.22c0.4531-1.4732 1.5-2.8155 3.1401-4.0254 1.6412-1.21 3.6973-2.1582 6.1705-2.8443 2.4726-0.686 5.1084-1.0293 7.9091-1.0293v-3.1152c-4.1406 0-7.9619 0.561-11.466 1.6826-3.5029 1.1221-6.2739 2.646-8.312 4.5718-2.0386 1.9258-3.0576 4.0132-3.0576 6.2617 0 2.2486 1.019 4.336 3.0576 6.2613 2.0381 1.9257 4.8091 3.4502 8.312 4.5722 3.5039 1.1211 7.3252 1.6826 11.466 1.6826v-3.0771c-2.8281 0-5.4736-0.3477-7.9365-1.041-2.4639-0.69341-4.5137-1.6446-6.1494-2.8531-1.6362-1.2084-2.6807-2.5439-3.1338-4.0058zm23.52 10.087c1.1719 0 2.1807-0.2246 3.0313-0.67191 0.8477-0.44819 1.2715-0.98629 1.2715-1.6162 0-0.6396-0.4238-1.1904-1.2715-1.6533-0.8506-0.4629-1.8594-0.6944-3.0313-0.6944-1.1523 0-2.1406 0.2315-2.9619 0.6944-0.8193 0.4629-1.2304 1.0137-1.2304 1.6533 0 0.6299 0.4111 1.168 1.2304 1.6162 0.8213 0.44731 1.8096 0.67191 2.9619 0.67191z"
          />
          <rect x=".0146" y="27.882" width="94.932" height="12" fill="url(#gradient1)" />
          <rect
            fill={isLight && !onDark ? DARK_COLOR : LIGHT_COLOR}
            x="-.0259"
            y="41.268"
            width="95.075"
            height="2.459"
          />
        </svg>
      </Box>
    </NextLink>
  );
}

export default Logo;
